import { createSlice } from "@reduxjs/toolkit";

const engineersSlice = createSlice({
  name: "engineers",
  initialState: {
    list: [],
  },
  reducers: {
    setEngineers: (state, action) => {
      state.list = action.payload;
    },
    updateEngineerStatus: (state, action) => {
      const { id, status } = action.payload;
      const engineer = state.list.find((eng) => String(eng.id) === String(id));
      if (engineer) {
        engineer.previousStatus = engineer.status;
        engineer.status = status;
      }
    },
  },
});

export const { setEngineers, updateEngineerStatus } = engineersSlice.actions;
export default engineersSlice.reducer;
